export function formatDateTimeText(value) {
  if (!value) return "-";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return "-";
  return dt.toLocaleString("zh-CN", { hour12: false });
}

export function toUtcDateTimeQueryValue(value) {
  if (!value) return "";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toISOString();
}

export function toDateTimeLocalInputValue(value) {
  const dt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dt.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return [
    dt.getFullYear(),
    pad(dt.getMonth() + 1),
    pad(dt.getDate())
  ].join("-") + `T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
}

export function getDefaultDateTimeRange() {
  const end = new Date();
  const start = new Date(end);
  start.setMonth(start.getMonth() - 1);
  return {
    startTime: toDateTimeLocalInputValue(start),
    endTime: toDateTimeLocalInputValue(end)
  };
}

export function formatSourceText(source) {
  if (source === "device") return "设备";
  if (source === "web") return "Web";
  return "未知";
}

export function formatCoordinate(longitude, latitude) {
  if (longitude == null || latitude == null) return "-";
  return `${Number(longitude).toFixed(6)}, ${Number(latitude).toFixed(6)}`;
}

export function formatSpeedText(speed) {
  if (speed == null || speed === "") return "-";
  const value = Number(speed);
  if (Number.isNaN(value)) return "-";
  return `${value.toFixed(1)} km/h`;
}
